<!-- 需求管理查看详情 -->
<template>
  <div class="releaseDetails">
    <!-- 背景图 -->
    <TopImg :title="topImg.title" :content="topImg.content" :image="topImg.bgImg" :bl="topImg.bl"></TopImg>
    <div class="barPath width">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/release' }">供需市场</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/release' }">需求管理</el-breadcrumb-item>
        <el-breadcrumb-item>需求名称</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="con width">
      <span class="shu"></span>
      <div class="title">{{listData.title}}</div>
      <div class="serveName" v-if="listData.status == 2">完成</div>
      <div class="serveName" v-if="listData.status == 3">服务商招标</div>
      <div class="serveName" v-if="listData.status == 4">预选服务商</div>
      <div class="serveName" v-if="listData.status == 5">线下对接</div>
      <div class="ss">{{listData.corporate}}</div>
    </div>
    <div class="ll width">
      <span class="shu"></span>
      <div class="item">
        <div class="item_ss">
          <span>提交时间：</span>
          <span>{{listData.end_time |formatDate4}}</span>
        </div>
        <div class="item_ss">
          <span>提交时间：</span>
          <span>{{listData.end_time |formatDate4}}</span>
        </div>
        <div class="item_ss">
          <span>提交时间：</span>
          <span>{{listData.end_time |formatDate4}}</span>
        </div>
      </div>
    </div>
    <div class="details width">
      <span class="shu"></span>
      <div class="lls clearfix">
        <span>需求详情：</span>
        <p>{{listData.content}}</p>
      </div>
    </div>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import TopImg from '../components/TopImg'
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { TopImg, Footer },
  props: {},
  data() {
    return {
      topImg: {
        title: '需求管理',
        bgImg: require('../assets/images/u2717.jpg'),
        content: '软硬件服务需求发布',
        bl: false,
      },
      listData: {},
      infoPar: '',
    }
  },
  computed: {},
  watch: {},
  created() {
    var zg = Object.values(this.$route.params)
    if (zg.length > 0) {
      sessionStorage.setItem('appinfoParss', JSON.stringify(this.$route.params))
    }
    this.getData()
  },
  mounted() {},
  methods: {
    async getData() {
      this.infoPar = JSON.parse(sessionStorage.getItem('appinfoParss'))
      const res = await this.$http.post('/demandInfo', this.infoPar)
      this.listData = res.data.data
    },
  },
}
</script>
<style lang="less" scoped>
.barPath {
  height: 48px;
  line-height: 48px;
  background-color: #fff;
  padding-left: 20px;
  box-sizing: border-box;
  margin-bottom: 10px;
  .el-breadcrumb {
    line-height: 48px;
    font-size: 16px !important;
  }
}
.shu {
  position: absolute;
  width: 6px;
  height: 46px;
  left: 20px;
  top: 10px;
  background-color: #1677ff;
}
.con {
  position: relative;
  padding: 20px 40px;
  box-sizing: border-box;
  background-color: #fff;
  .shu {
    position: absolute;
    width: 6px;
    height: 46px;
    left: 20px;
    top: 10px;
    background-color: #1677ff;
  }
  .title {
    font-size: 24px;
    font-weight: 700;
  }
  .serveName {
    font-weight: 400;
    color: #f59a23;
    font-size: 18px;
    line-height: 30px;
    margin: 10px 0;
  }
}
.ll {
  position: relative;
  padding: 20px 40px;
  box-sizing: border-box;
  background-color: #fff;
  margin-top: 10px;

  .item {
    display: flex;
    height: 30px;
    justify-content: center;
    align-items: center;
    .item_ss {
      flex: 1;
    }
  }
}
.details {
  position: relative;
  background-color: #fff;
  margin-top: 10px;
  padding: 20px 40px;
  box-sizing: border-box;
  margin-bottom: 10px;
  .lls {
    span {
      float: left;
      line-height: 30px;
    }
    p {
      float: left;
      width: 94%;
      height: 200px;
      border: 1px solid #1677ff;
      margin: 0;
      padding: 10px;
      box-sizing: border-box;
    }
  }
}
</style>
